<template lang="html">
  <div class="greeting-list-container" v-if="greetings">
    <div class="search media">
      <div class="media-body row">
        <div class="col">
          <search-input
            @search="searchGreetingWithName"
            :placeholder="$t('label.search')">
          </search-input>
        </div>
        <div class="col">
          <search-input
            @search="searchGreetingWithHome"
            :placeholder="$t('label.search_home_project')">
          </search-input>
        </div>
      </div>
    </div>
    <div class="col p-0 greeting-list">
      <greeting-navigation :greetings="membersFilter" />
      <!-- <infinite-loading @infinite="infiniteHandler" spinner="spiral" ref="infiniteLoading">
        <span slot="no-results"/>
        <span slot="no-more"/>
      </infinite-loading> -->
    </div>
    <greeting-summary v-if="keyword === ''" :total="membersFilter.length" />
  </div>
</template>
<script>
import axios from "axios";
import InfiniteLoading from "vue-infinite-loading";
import SearchInput from "@/components/helper/SearchInput";
import GreetingNavigation from "./GreetingNavigation";
import GreetingSummary from "./GreetingSummary";

export default {
  props: {
    greetings: {
      type: Array
    }
  },
  components: {
    SearchInput,
    InfiniteLoading,
    GreetingSummary,
    GreetingNavigation
  },
  computed: {
    membersFilter() {
      return this.greetings || [];
    }
  },
  data() {
    return {
      // greetings: [],
      isLoading: false,
      keyword: "",
      searchName: "",
      searchHome: ""
    };
  },
  mounted() {},
  methods: {
    searchGreetingWithName(searchName) {
      const searchHome = this.searchHome;
      this.searchName = searchName;
      this.$emit("search", { searchName, searchHome });
    },
    searchGreetingWithHome(searchHome) {
      const searchName = this.searchName;
      this.searchHome = searchHome;
      this.$emit("search", { searchName, searchHome });
    },
    infiniteHandler($state) {
      if (!this.isLoading) {
        this.isLoading = true;
        this.loadGreetings()
          .then(greetings => {
            this.isLoading = false;
            this.greetings = greetings;
            $state.complete();
          })
          .catch(error => {
            this.isLoading = false;
            $state.complete();
          });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.search {
  border-bottom: 1px solid #e0e0e0;
  padding: 10;
}
.greeting-list-container {
  background: white;
  border-right: solid 1px #e0e0e0;
  padding: 0;
}
.greeting-list {
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/view/greeting/GreetingList.vue